import React, { useEffect } from 'react';
import { useStore } from '../../zustand';
// Core Components
import ViewSpaceBtn from '../ButtonsUI/ViewSpaceBtn';
import ARLaunch from '../ButtonsUI/ARLaunch';
// Helpers
//import { setARCartURL, _setCustomBannerURL, setSessionID } from "../../utility/helpers";
import { setARCartURL } from "../../utility/helpers";
// import { sendAnalyticsData } from "../../utility/handleAnalytics";
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { arBtnStyles } from "../../assets/jss/arBtnStyles";
// import ARicon from '../../assets/icons/ar_logo.svg';
// Styles
const useStyles = makeStyles(arBtnStyles);
// Variables
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;


export default function FooterDefault() {
    const { intent } = useStore.getState().hrx;
    const variant_id = useStore(state => state.variant_id);
    const { store_id, vList } = useStore.getState().variants_payload;
    const { variant_type } = useStore.getState().settings;
    const actions = useStore(state => state.actions);
    const { ar_activation } = useStore.getState().settings;
    const { dynamic_text_settings, custom_banner_url, ar_experience } = useStore.getState().store_settings;
    const model_loaded = useStore(state => state.model_loaded);
    const anchor_tag = React.useRef(null)
    const classes = useStyles(dynamic_text_settings);

    // useEffect(() => {
        // if(anchor_tag.current !== null) {
            // console.log('gere', anchor_tag.current)
        // if((intent === 'willQL') && !ar_activation && ar_experience?.ar_cta_status) {
            // anchor_tag.current.addEventListener("message", async function (event) {
                // alert('anchor_tag')
    //             // eslint-disable-next-line
                // if (event.data == "_apple_ar_quicklook_button_tapped") {
    //                 actions.setFullScreenLoading(true)
    //                 const qlBannerLink = setARCartURL(variant_id, vList, variant_type, ar_experience.ar_cta_type)
    //                 await sendAnalyticsData({ event_type: 'cart_ar_add' });
                    
    //                 setTimeout(() => {
    //                     actions.setFullScreenLoading(false)
    //                 }, 3000)
    //                 window.location.assign(qlBannerLink);
                // }
            // }, false);
        // }
    // }, [])
    // console.log('model_loaded', model_loaded)
    useEffect(() => {
        if (anchor_tag.current !== null) {
            console.log('HERE')
                anchor_tag.current.addEventListener(
                    'message',
                    (event) => {
                    // eslint-disable-next-line
                    if (event.data == '_apple_ar_quicklook_button_tapped') {
                        actions.setFullScreenLoading(true)
                        const qlBannerLink = setARCartURL(variant_id, vList, variant_type, ar_experience.ar_cta_type)
                        setTimeout(() => {
                            actions.setFullScreenLoading(false)
                        }, 3000)
                        window.location.assign(qlBannerLink);
                    }
                },
                false
            )
        }
    }, [model_loaded, vList, actions, variant_id, variant_type, ar_experience])

    // const _generateLink = () => {
    //     const dt = `${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.usdz#allowsContentScaling=0`;
    //     const custom_cta = ar_experience?.ar_cta_status ? _setCustomBannerURL(variant_id, variant_type) : "";
    //     console.log('custom_cta', custom_cta)
    //     const quickLookURL = `${dt}${custom_cta}`;
    //     return quickLookURL;
    // }
    
    // console.log('intent', intent)
    // console.log('ar_activation', ar_activation)

    return (
        <div className={classes.bottomActions} style={{ width: '100%', position: 'fixed', bottom: '1em', zIndex: 9, padding: '0 1em' }}>
            { ((intent === 'willQL') && !ar_activation) &&
                (
                    <div className={classes.button_container_default}>
                        <a 
                            id="ar-link"
                            rel="ar"
                            ref={anchor_tag}
                            href={`${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.usdz#allowsContentScaling=0${custom_banner_url}`}
                        >
                            <img src="https://levar-viewer-settings.s3.amazonaws.com/icons/ar_logo.png" alt="AR" style={{ width: 23, pointerEvents: 'none' }} />
                        </a>
                    </div>
                )
            }
            { ((intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV') || ar_activation) &&
                <ARLaunch design="normal" />
            }
            { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                <ViewSpaceBtn /> 
            }
        </div>
    );
}

// {/* <a 
//     id="ar-link"
//     rel="ar"
//     ref={anchor_tag} 
//     href={_generateLink()}
// >
//     <img src={ARicon} alt="AR" className={classes.button_ar_default} />
//     <span className={classes.ar_text}>{dynamic_text_settings.mobile_ar_button.button_text}</span>
// </a> */}



